import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import axios from 'axios';
import {Button} from 'primereact/button';
import {InputNumber} from 'primereact/inputnumber';
import {hasRole} from '../../../../utils/hasRole';

export const PurchaseorderStockTransferComponent = ({documentId, t, onDeleted}) => {
  const [document, setDocument] = useState(null);
  const [quantities, setQuantities] = useState({});
  const [busy, setBusy] = useState(false);
  const canWrite = hasRole('ROLE_INVENTORY_TRANSFER_2ST_WRITE');
  const editable = canWrite && document?.status === 'DRAFT';
  const api = (method, path, data) => axios({method, url: process.env.REACT_APP_API_HOST + '/api/v2/' + path, data,
    headers: {Authorization: 'Bearer ' + localStorage.getItem('userToken'), 'App-Network': localStorage.getItem('networkId')}});
  const load = async (savedItemId = null) => {
    const response = await api('get', 'inventory-document/' + documentId);
    const data = response.data.data;
    setDocument(data);
    setQuantities(previous => Object.fromEntries((data.items || []).map(item => {
      const old = document?.items?.find(entry => entry.id === item.id);
      const keepEdit = savedItemId !== null && item.id !== savedItemId && old && previous[item.id] !== Number(old.quantity);
      return [item.id, keepEdit ? previous[item.id] : Number(item.quantity)];
    })));
  };
  const run = async task => {
    setBusy(true);
    try {
      await task();
      window.App.setState({rerenderPurchaseorderInventorydocumentList: Math.random(), rerenderPurchaseorderShow: Math.random(), rerenderPurchaseorderitemList: Math.random()});
    } catch (error) { window.App.toastShow('error', t('error'), error.toString(), '', error.response); }
    finally { setBusy(false); }
  };
  useEffect(() => { run(load); }, [documentId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!document) return <p>{t('loading')}</p>;
  const items = document.items || [];
  const unsaved = items.some(item => Number(item.quantity) !== quantities[item.id]);
  return <div>
    <h3>{document.document_number} #{document.id}</h3>
    <p>{document.warehouse_from?.name} → {document.warehouse_to?.name}</p>
    <p>{t(document.status === 'DRAFT' ? 'stockReservationHint' : 'stockTransferCompleted')}</p>
    <table className="p-datatable-table" style={{width: '100%'}}>
      <thead><tr><th>{t('columnProduct')}</th><th>{t('fieldQuantity')}</th><th>{t('columnReservedStock')}</th><th/></tr></thead>
      <tbody>{items.map(item => <tr key={item.id}>
        <td>{item.material?.name}</td>
        <td><InputNumber aria-label={`${t('fieldQuantity')} ${item.material?.name}`} value={quantities[item.id]} min={0.001} maxFractionDigits={3}
          disabled={!editable || busy} onValueChange={event => setQuantities(previous => ({...previous, [item.id]: event.value}))}/> {item.unit?.name}</td>
        <td>{item.reserved_quantity ?? 0} {item.unit?.name}</td>
        <td>{editable && <>
          <Button label={t('save')} icon="pi pi-save" disabled={busy || !(quantities[item.id] > 0)} onClick={() => run(async () => {
            await api('patch', 'inventory-document-item/transfer-2st/' + item.id, {quantity: quantities[item.id]}); await load(item.id);
          })}/>
          <Button label={t('delete')} icon="pi pi-trash" className="p-button-danger p-ml-2" disabled={busy} onClick={() => {
            if (window.confirm(t('stockReservationDeleteLineConfirm'))) run(async () => { await api('delete', 'inventory-document-item/' + item.id); await load(); });
          }}/>
        </>}</td>
      </tr>)}</tbody>
    </table>
    {editable && <div className="p-mt-3">
      <Button label={t('stockTransferComplete')} icon="pi pi-check" className="p-button-success" disabled={busy || !items.length || unsaved}
        onClick={() => { if (window.confirm(t('stockTransferCompleteConfirm'))) run(async () => {
          await api('post', 'inventory-document/transfer-2st/' + documentId + '/complete'); await load();
        }); }}/>
      <Button label={t('stockReservationCancel')} icon="pi pi-trash" className="p-button-danger p-ml-2" disabled={busy}
        onClick={() => { if (window.confirm(t('stockReservationCancelConfirm'))) run(async () => {
          await api('delete', 'inventory-document/transfer-2st/' + documentId); onDeleted();
        }); }}/>
      {unsaved && <p>{t('stockReservationSaveFirst')}</p>}
    </div>}
  </div>;
};
export default withTranslation('common')(PurchaseorderStockTransferComponent);
